<template>
  <div>
    <div v-if="divider" class="text-center pb-2 d-flex justify-center">
      <span class="mx-1">.</span>
      <span class="mx-1">.</span>
      <span class="mx-1">.</span>
    </div>
    <v-list-item v-else class="px-8" :class="{ 'own': own }">
      <v-list-item-icon class="mr-3">
        {{ rank }}
      </v-list-item-icon>

      <v-list-item-avatar class="mr-4 justify-center">
        <BaseAvatar v-if="own" size="40" />
        <BaseAvatar v-else :img="avatar" default size="40" />
        <!-- <v-img
          v-else
          :src="avatar"
          :alt="`${name} avatar`"
        ></v-img> -->
      </v-list-item-avatar>

      <v-list-item-content>
        <v-list-item-title v-text="name"></v-list-item-title>
      </v-list-item-content>
    </v-list-item>
    <v-divider />
  </div>
</template>

<style scoped>
  .own {
    background: var(--v-secondary-base);
  }
</style>

<script>
export default {
  name: 'RankingListItem',
  props: {
    name: {
      type: String,
      default: '',
    },
    avatar: {
      type: String,
      default: '',
    },
    rank: {
      type: String,
      default: '',
    },
    own: {
      type: Boolean,
      default: false,
    },
    divider: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
